export const TYPE = '@type';